import React, { useEffect, useState } from 'react';
import { Button, Col, Form, Row } from 'antd';
import { FormBox, InputBox } from '../../../../components/AntdAddons';
import { validations } from '../../../../config/validations/validations';
import SVGIcon from '../../../../utils/SVGIcon';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../../../store/app';
import { addInternalCode } from '../../../../store/NumberManagementSlice';

const ProviderCodeForm: React.FC<any> = ({ getList, messageAction }) => {
  const [form] = Form.useForm();
  const dispatch: AppDispatch = useDispatch();

  const [loading, setLoading] = useState<boolean>(false);

  const handleSubmit = (data?: any) => {
    setLoading(true);

    dispatch(addInternalCode(data))
      .then((res: any) => {
        setLoading(false);
        getList();
        form.resetFields();
      })
      .catch(() => {
        setLoading(false);
      });
  };
  // for validation
  const handleChange = () => {
    form
      .validateFields()
      .then(() => {
        // setDisable(false);
      })
      .catch((error: any) => {
        // setDisable(true);
      });
  };

  useEffect(() => {
    form.setFieldValue('message_action', messageAction);
  }, [form, messageAction]);

  return (
    <>
      <FormBox
        className="filterForm"
        form={form}
        onFinish={handleSubmit}
        onChange={handleChange}
        validateTrigger={['onBlur', 'onInput']}
        autoComplete="off"
      >
        <Row
          gutter={[20, 0]}
          align={'bottom'}
        >
          <Col
            xs={24}
            md={12}
            lg={7}
            xxl={6}
          >
            <InputBox.Text
              label="Code"
              name={'code'}
              required
              rules={[validations.required.text('Code'), validations.pattern.whitespace]}
            />
          </Col>
          <Col
            xs={24}
            md={12}
            lg={7}
            xxl={6}
          >
            <InputBox.Text
              label="Code Name"
              name={'name'}
              required
              rules={[validations.required.text('Code Name'), validations.pattern.whitespace]}
            />
          </Col>
          <Col
            xs={24}
            md={24}
            lg={10}
            xxl={10}
          >
            <InputBox.Text
              label="Description"
              name={'description'}
              rules={[validations.pattern.whitespace]}
            />
          </Col>
          {/* <Col xs={24} md={12} lg={6} xxl={6}>
            <InputBox.Text
              label='Provider Code'
              name={'provider_code'}
              tooltip='A single phone number to request to be ported.
                    Must be in a domestic form (e.g. 0551234567 or 03123456)'
              required
            //   rules={[validations.required.text('Number')]}
            />
          </Col> */}

          <Col
            xs={12}
            md={12}
            lg={6}
            xl={3}
          >
            {/* <Form.Item label=' '> */}
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
            >
              <SVGIcon
                icon="add"
                color="#fff"
                width={55}
              />{' '}
              Add
            </Button>
            {/* </Form.Item> */}
          </Col>
          <Col
            xs={12}
            md={12}
            lg={6}
            xl={3}
          >
            {/* <Form.Item label=' '> */}
            <Button
              type="default"
              htmlType="reset"
              onClick={getList}
            >
              Clear
            </Button>
            {/* </Form.Item> */}
          </Col>
        </Row>
      </FormBox>
    </>
  );
};

export default ProviderCodeForm;
